module.exports = "<fine-reimbursement-page></fine-reimbursement-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/fineReimbursementView.html
// module id = 2240
// module chunks = 0